import ToggleButton from './ToggleButton'

export default ToggleButton



// WEBPACK FOOTER //
// ./src/app/components/common/toggleButton/index.js